// ==========================================================================
//	捲軸事件相關 的 directives
//
//  directives：
//		
//  	scrollToFixed：當scroll到所給的值，該directive 的 element 就會fixed在該位置
//
//	@author：Gray
//	@createtime：2016 / 12 / 13 by Gray
// ==========================================================================

window.InifECApp.directive('scrollToFixed',['$rootScope', '$timeout', '$state',
    function($rootScope, $timeout, $state) {
        var _dir = {};

        var link = function(scope, element, attrs) {

            if(!attrs.scrollToFixed) {
                return;
            }

            var scrollToFixed = attrs.scrollToFixed,
                $window = $(window),
                isFixed = false,
                isWaitInit = attrs.isWaitInit == 'true',
                keepHeight = attrs.keepHeight == 'true',
                keepItem = undefined,
                offset = undefined,
                needToFixed = 0,
                delayToFixed = 0,
                itemWidth = 0,
                itemHeight = 0,
                toogleClass = attrs.toogleClass,
                isAddClass = false,
                needToogleClass = 0,
                offsetItem = undefined,
                fixCallback = attrs.fixCallback,
                stopStateChangeReset = attrs.stopStateChangeReset == 'true';

            var _bindScroll = function(isRemoveVisibility) {
                var scrollTop = $(window).scrollTop();

                // element.css({
                //     'position': '',
                //     'top': '',
                //     'width': ''
                // });

                if(!offsetItem) {
                    return;
                }

                offset = offsetItem.offset();

                var dy = scrollTop - (offset.top - needToFixed + delayToFixed);

                isFixed = dy >= 0;

                if(isFixed) {
                    element.css({
                        'position': 'fixed',
                        'top': needToFixed,
                        'width': itemWidth
                    });

                    if(keepItem) {
                        keepItem.css({
                            height: itemHeight,
                        });
                    }
                } else {
                    element.css({
                        'position': '',
                        'top': '',
                        'width': ''
                    });

                    if(keepItem) {
                        keepItem.css({
                            height: 0,
                        });
                    }
                }

                if(toogleClass) {
                    isAddClass = dy - needToogleClass >= 0;

                    if(isAddClass) {
                        element.addClass(toogleClass);
                    } else {
                        element.removeClass(toogleClass);
                    }
                }

                // if(isRemoveVisibility) {
                //     element.css({
                //         visibility: '',
                //     });
                // }

                if(fixCallback) {
                    scope.$evalAsync(fixCallback + '("' + isFixed + '")');
                }
            }

            var bindScroll = function() {

                // if(isFixed) {
                    throttle(_bindScroll(), 10);
                // } else {
                    // _bindScroll()
                // }
            }

            var bindResize = function() {

                // element.css({
                //     'position': '',
                //     'top': '',
                //     'width': ''
                // });

                // offset = element.offset();
                // itemWidth = element.outerWidth();

                itemWidth = offsetItem && offsetItem.outerWidth();

                _bindScroll();
            }

            var bindEvent = function() {

                $(window).off('scroll.' + scrollToFixed).on('scroll.' + scrollToFixed, bindScroll);
                $(window).trigger('scroll.' + scrollToFixed);
                $(window).off('resize.' + scrollToFixed).on('resize.' + scrollToFixed, bindResize);
            }

            var offEvent = function() {

                $(window).off('scroll.' + scrollToFixed);
                $(window).off('resize.' + scrollToFixed);
            }

            var init = function() {

                if(isWaitInit) {
                    return;
                }

                var state = $state.current.name;

                needToFixed = attrs.needToFixed ? parseFloat(attrs.needToFixed) : 0;
                delayToFixed = attrs.delayToFixed ? parseFloat(attrs.delayToFixed) : 0;
                needToogleClass = attrs.needToogleClass ? parseFloat(attrs.needToogleClass) : 0;

                if(keepHeight) {
                    itemHeight = element.outerHeight(true);
                    keepItem = $('<div>');
                    keepItem.insertAfter(element);
                    keepItem.css({
                        height: 0,
                    });
                }

                // 建一個假的在畫面上計算位置和寬度
                offsetItem = $('<div>');
                offsetItem.addClass(element[0].className);
                offsetItem.insertBefore(element);
                offsetItem.css({
                    position: 'absolute',
                    visibility: 'hidden',
                });

                itemWidth = offsetItem && offsetItem.outerWidth();

                bindEvent();
            }

            scope.$on('CUPOY_SCROLLTOFIXED_INIT', function(event, data) {
                if(data && isWaitInit && data.scrollToFixed == scrollToFixed) {
                    isWaitInit = false;
                    $timeout(function() {
                      init();
                    });
                }
            });

            scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {

                if(stopStateChangeReset) {
                    return;
                }

                // element.css({
                //     visibility: 'hidden',
                // });

                element.css({
                    'position': '',
                    'top': '',
                    'width': ''
                });

                if(toogleClass) {
                    element.removeClass(toogleClass);
                }

                if(keepItem) {
                    keepItem.css({
                        height: 0,
                    });
                }

                $timeout(function() {
                    bindResize();
                });
            });

            scope.$on('$destroy', function() {
                offEvent();
            });

            $timeout(function() {
                init();    
            });
        }

        _dir.restrict = "A";
        _dir.link = link;

        return link;
    }
]);

window.InifECApp.directive('autoBottomFixed',['$rootScope', '$timeout',
    function($rootScope, $timeout) {
        var _dir = {};

        var link = function(scope, element, attrs) {

            if(!attrs.autoBottomFixed) {
                return;
            }

            var autoBottomFixed = attrs.autoBottomFixed,
                refreshOnChange = attrs.refreshOnChange,
                keepItem = undefined;

            var bindEvent = function() {

                $(window).off('resize.' + autoBottomFixed).on('resize.' + autoBottomFixed, checkNeedToFixed);
            }

            var offEvent = function() {

                $(window).off('resize.' + autoBottomFixed);
            }

            var checkNeedToFixed = function() {

                if(keepItem) {
                    keepItem.remove && keepItem.remove();
                    keepItem = undefined;
                }

                element.css({
                    position: '',
                    width: '',
                    height: '',
                    bottom: '',
                });

                var needToFixed = attrs.needToFixed ? parseFloat(attrs.needToFixed) : 0;
                var offset = element.offset();
                var itemWidth = element.outerWidth();
                var itemHeight = element.outerHeight(true);
                var windowHeight = window.innerHeight;
                var isFixed = (offset.top + itemHeight + needToFixed) >= windowHeight;

                if(isFixed) {
                    keepItem = $('<div>');
                    keepItem.insertAfter(element);
                    keepItem.css({
                        height: itemHeight,
                    });

                    element.css({
                        position: 'fixed',
                        width: itemWidth,
                        height: itemHeight,
                        bottom: needToFixed,
                    });
                }
            }

            var init = function() {

                if(refreshOnChange) {

                    if(Array.isArray(refreshOnChange)) {
                        scope.$watchGroup(refreshOnChange, function() {
                            checkNeedToFixed();
                        });
                    } else {
                        scope.$watchCollection(refreshOnChange, function() {
                            checkNeedToFixed();
                        });
                    }
                }

                bindEvent();
                checkNeedToFixed();
            }

            scope.$on('$destroy', function() {
                offEvent();
            });

            $timeout(function() {
                init();    
            });
        }

        _dir.restrict = "A";
        _dir.link = link;

        return link;
    }
]);